import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import { MerchantsChannelsTypes } from './types'
import {
  viewMerchantChannelPaymentsSuccess,
  viewMerchantChannelPaymentsFailure,
  exportMerchantChannelPaymentsSuccess,
  exportMerchantChannelPaymentsFailure
} from './actions'
import { callApiPost } from '../../utils/api'
import { DataStream } from '../../interfaces'
import { path } from '../../helpers/path'
import { logout } from '../auth'

function* getChannels({ payload }: { type: string; payload: any }): any {
  try {
    const res = yield call(
      callApiPost,
      'reports/viewmerchantchannelpayments',
      payload
    )
    if (res.status === 200) {
      yield put(viewMerchantChannelPaymentsSuccess(res.data))
    } else {
      yield put(viewMerchantChannelPaymentsFailure('An unknown error occurred'))
    }
  } catch (err: any) {
    if (err && err.response) {
      if (err.response.status === 401) {
        yield put(logout())
        localStorage.removeItem('user')
        localStorage.removeItem('persist:root')
        localStorage.clear()
        window.location.href = path.login
      } else {
        yield put(viewMerchantChannelPaymentsFailure(err.response.data))
      }
    } else {
      yield put(viewMerchantChannelPaymentsFailure('An unknown error occurred'))
    }
  }
}

function* getExportChannels({ payload }: { type: string; payload: any }): any {
  try {
    const res = yield call(
      callApiPost,
      'reports/viewmerchantchannelpaymentsexport',
      payload
    )
    if (res.status === 200) {
      yield put(exportMerchantChannelPaymentsSuccess(res.data))
      let file: DataStream = res.data
      const link = document.createElement('a')
      link.href = `data:${file.contentType};base64,${file.fileContents}`
      link.download = file.fileDownloadName
      link.click()
    }
  } catch (err: any) {
    if (err && err.response) {
      if (err.response.status === 401) {
        yield put(logout())
        localStorage.removeItem('user')
        localStorage.removeItem('persist:root')
        localStorage.clear()
        window.location.href = path.login
      } else {
        yield put(exportMerchantChannelPaymentsFailure(err.response.data))
      }
    } else {
      yield put(exportMerchantChannelPaymentsFailure('An unknown error occurred'))
    }
  }
}

function* watchGetChannels() {
  yield takeEvery(
    MerchantsChannelsTypes.VIEW_MERCHANT_CHANNEL_PAYMENTS_REQUEST,
    getChannels
  )
}

function* watchExportChannels() {
  yield takeEvery(
    MerchantsChannelsTypes.EXPORT_MERCHANT_CHANNEL_PAYMENTS_REQUEST,
    getExportChannels
  )
}

function* channelSaga(): Generator {
  yield all([fork(watchGetChannels), fork(watchExportChannels)])
}

export { channelSaga }
